import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import type { PlanCurrency, PlanId, SubscribeResponse } from "./types";

export const useSubscribeMutation = () => {
  const fetch = useAuthFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: { plan: PlanId; currency: PlanCurrency }) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/tribute/subscribe`,
        {
          method: "POST",
          body: JSON.stringify(params),
        }
      );
      const data: SubscribeResponse = await response.json();
      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["api", "tribute", "subscription"],
      });
    },
  });
};
